import React, { useContext, useMemo } from "react";
import { EntityIdentifier } from "module/entity/types";
import {
  CertificationInterface,
  CertificationSessionInterface,
} from "module/certification/types";
import CertificationContext from "module/certification/context/CertificationContext";
import CertificationSessionContext from "module/certificationSession/context/CertificationSessionContext";
import EntityContextProvider from "module/entity/context/entity/EntityContextProvider";

interface CertificationSessionContextProviderProps {
  entityIdentifier: EntityIdentifier;
  children: React.ReactNode;
}

const CertificationSessionContextProvider: React.FC<CertificationSessionContextProviderProps> =
  ({ entityIdentifier, children }) => {
    const { entity } = useContext(CertificationContext);

    const certification = entity as CertificationInterface;

    const session = useMemo(
      () =>
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        certification.relationships.get(entityIdentifier)
          .data as CertificationSessionInterface,
      [entityIdentifier, certification.relationships]
    );

    return (
      <EntityContextProvider
        {...{ entity: session, context: CertificationSessionContext }}
      >
        {children}
      </EntityContextProvider>
    );
  };

export default CertificationSessionContextProvider;
